import React from 'react'
import { useState } from "react"; // import state
import NavigationModal from '../components/GlobalNav'
import FullIngredientsModal from '../components/FullIngredientsModal'
import RecyclingModal from '../components/RecyclingModal';

import { Helmet } from 'react-helmet'

import './sunrise.css'


const Line = (props) => {
  return(
    <svg width='341' height='1' viewBox='0 0 341 1' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <line y1='0.75' x2='341' y2='0.75' stroke='black' strokeWidth='0.5'/>
    </svg>
  )
}

const FBNegative = (props) => {
  return(
    <a className="sunrise-facebook-negative" href="https://www.facebook.com/hugoboss" target="_blank">
      <svg width='20' height='21' viewBox='0 0 20 21' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <g clipPath='url(#clip0_39_677)'>
          <path d='M20 10.4857C20 4.96281 15.5229 0.485657 10 0.485657C4.47715 0.485657 0 4.96281 0 10.4857C0 15.4769 3.65684 19.614 8.4375 20.3642V13.3763H5.89844V10.4857H8.4375V8.28253C8.4375 5.77628 9.93047 4.39191 12.2146 4.39191C13.3084 4.39191 14.4531 4.58722 14.4531 4.58722V7.04816H13.1922C11.95 7.04816 11.5625 7.81906 11.5625 8.61066V10.4857H14.3359L13.8926 13.3763H11.5625V20.3642C16.3432 19.614 20 15.4769 20 10.4857Z' fill='black' />
        </g>
        <defs>
          <clipPath id='clip0_39_677'>
            <rect width='20' height='20' fill='white' transform='translate(0 0.485657)' />
          </clipPath>
        </defs>
      </svg>
    </a>
  )
}

const TwitterNegative = (props) => {
  return(
    <a className="sunrise-twitter-negative" href="https://x.com/hugoboss?lang=en" target="_blank">
      <svg width='20' height='21' viewBox='0 0 20 21' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <g clipPath='url(#clip0_39_678)'>
          <path d='M6.2918 18.6107C13.8371 18.6107 17.9652 12.3579 17.9652 6.93724C17.9652 6.76146 17.9613 6.58177 17.9535 6.40599C18.7566 5.82524 19.4496 5.1059 20 4.28177C19.2521 4.61452 18.458 4.83184 17.6449 4.9263C18.5011 4.41311 19.1421 3.60691 19.4492 2.65716C18.6438 3.13449 17.763 3.4712 16.8445 3.65286C16.2257 2.99532 15.4075 2.55995 14.5164 2.41406C13.6253 2.26818 12.711 2.4199 11.9148 2.84577C11.1186 3.27164 10.4848 3.94794 10.1115 4.77011C9.73825 5.59229 9.64619 6.51453 9.84961 7.39427C8.21874 7.31243 6.62328 6.88877 5.16665 6.15077C3.71002 5.41276 2.42474 4.37688 1.39414 3.11028C0.870333 4.01339 0.710047 5.08206 0.945859 6.0991C1.18167 7.11613 1.79589 8.00523 2.66367 8.58568C2.01219 8.56499 1.37498 8.38959 0.804688 8.07396V8.12474C0.804104 9.07248 1.13175 9.99118 1.73192 10.7247C2.3321 11.4581 3.16777 11.9612 4.09687 12.1482C3.49338 12.3133 2.85999 12.3374 2.2457 12.2185C2.50788 13.0336 3.01798 13.7464 3.70481 14.2576C4.39164 14.7688 5.22093 15.0529 6.07695 15.07C4.62369 16.2116 2.82848 16.8308 0.980469 16.8279C0.652739 16.8274 0.325333 16.8073 0 16.7677C1.87738 17.9721 4.06128 18.6118 6.2918 18.6107Z' fill='black' />
        </g>
        <defs>
          <clipPath id='clip0_39_678'>
            <rect width='20' height='20' fill='white' transform='translate(0 0.485657)' />
          </clipPath>
        </defs>
      </svg>
    </a>
  )
}

const InstaNegative = (props) => {
  return(
    <a className="sunrise-instagram-negative" href="https://www.instagram.com/boss/" target="_blank">
      <div className="sunrise-group1">
        <img
          alt="VectorI396"
          src="/external/vectori396-dtkr.svg"
          className="sunrise-vector1"
        />
        <img
          alt="VectorI396"
          src="/external/vectori396-iaef.svg"
          className="sunrise-vector2"
        />
        <img
          alt="VectorI396"
          src="/external/vectori396-3oud.svg"
          className="sunrise-vector3"
        />
      </div>
    </a>
  );
}

const Heading = (props) => {
  return(
    <div className="sunrise-heading">
      <span>{props.text}</span>
      <a name={props.anchor}></a>
      <Line />
    </div>
  )
}

const Sunrise = (props) => {
  const [isOpen, setOpen] = useState(false);
  const [isROpen, setROpen] = useState(false);
  const [isNavOpen, setNavOpen] = useState(false);
  const [language, setLanguage] = useState('FRA');

  return (
    <NavigationModal isOpen={isNavOpen} setOpen={setNavOpen} modalSetLanguage={setLanguage}>
      <RecyclingModal isOpen={isROpen} setOpen={setROpen} lang={language}>
        <FullIngredientsModal isOpen={isOpen} setOpen={setOpen} >
          <div className="sunrise-landing-container">
            <Helmet>
              <title>BOSS Bottled Eau de Toilette for Men</title>
            </Helmet>

            <div className="sunrise-landing">
              <div className="sunrise-landing-header2">
                <div className="sunrise-landing-logo2">
                  <img
                    alt="image293964"
                    src="/external/image293964-dx2-200h.png"
                    className="sunrise-landing-image29"
                  />
                </div>
                <div className="sunrise-landing-burger2" onClick={() => setNavOpen((prev) => !prev)} >
                  <img
                    alt="Line983964"
                    src="/external/line983964-fmj4.svg"
                    className="sunrise-landing-line98"
                  />
                  <img
                    alt="Line1003964"
                    src="/external/line1003964-srb.svg"
                    className="sunrise-landing-line100"
                  />
                  <img
                    alt="Line1013964"
                    src="/external/line1013964-abze.svg"
                    className="sunrise-landing-line101"
                  />
                </div>
              </div>

              <div className="sunrise-landing-frame281">
                <div className="sunrise-landing-media-gallery-mobile">
                  <div className="sunrise-landing-slider">
                    <img
                      alt="Image3965"
                      src="/external/image3965-xrl-300h.png"
                      className="sunrise-landing-image"
                    />
                  </div>
                  <img
                    alt="SliderIndicators3965"
                    src="/external/sliderindicators3965-1w8l.svg"
                    className="sunrise-landing-slider-indicators"
                  />
                </div>
                <div className="sunrise-landing-description-mobile">
                  <span className="sunrise-landing-text102 MOBILEBODYCOPY">
                    <span>
                      BOSS Bottled <br/> Eau de Toilette for Men <br/>100 ml ℮ ( 3,3 FL. OZ.)
                    </span>
                  </span>
                </div>
              </div>
              <div className="sunrise-container">
                <div className="sunrise-group">
                  <Heading text="ABOUT" anchor="about" />
                  <div className="sunrise-body">
                    <div className="sunrise-body-sub">
                      <div className="sunrise-body-sub-sub">
                        <span className="sunrise-text HEADING">
                          THE SCENT STORY
                        </span>
                        <span className="sunrise-quote">
                          &quot;A fruity, woody fragrance full of confidence,
                          freshness and strength&quot;
                        </span>
                        <span className="sunrise-subtext">
                          <div className="sunrise-padding">
                            <span className="sunrise-subtext">TOP NOTES</span>
                            <span className="sunrise-sub-subtext">Apple</span>
                          </div>
                          <div className="sunrise-padding">
                            <span className="sunrise-subtext">HEART NOTES</span>
                            <span className="sunrise-sub-subtext">Cinnamon, Geranium</span>
                          </div>
                          <div className="sunrise-padding">
                            <span className="sunrise-sub-subheading">BASE NOTES</span>
                            <span className="sunrise-sub-subtext">Sensual Woods</span>
                          </div>
                        </span>
                      </div>
                      <span className="sunrise-text145 MOBILEBODYCOPY">
                        <span>
                          &quot;Radiate confidence with BOSS Bottled Eau de Toilette
                          for Men. This fresh and masculine fragrance – designed to
                          carry the modern man through whatever the day brings – is
                          instantly recognizable with its fruity, woody aroma.
                        </span>
                        <br></br>
                        <br></br>
                        <span>
                          Crafted by master perfumer Annick Menardo in 1998, the
                          original BOSS Bottled quickly gained icon status as the
                          first male gourmand scent. Just as legendary today, this
                          BOSS perfume stands out with a fresh Apple top note and a
                          spicy Cinnamon heart. Its rich base exudes strength with a
                          deep Wood note.
                        </span>
                        <br></br>
                        <span>
                          The timeless BOSS Bottled flacon makes a refined impression
                          in clear glass with a brushed silver cap.
                        </span>
                        <br></br>
                        <span>
                          Be Your Own BOSS with BOSS Bottled Eau de Toilette, a woody
                          fruity fragrance for men.&quot;
                        </span>
                      </span>
                      <div className="sunrise-text-group">
                        <span className="sunrise-text159 HEADING">
                          BRAND STORY
                        </span>
                        <span className="sunrise-text161 MOBILEBODYCOPY">
                            BOSS Perfumes have been expertly crafted to reflect the
                            powerful personality of the BOSS man and woman, featuring
                            a range of refined and contemporary perfumes tailored to
                            enhance the look of the wearer and complement their modern
                            lifestyle.
                        </span>
                        <div className="sunrise-group384">
                          <a href="http://hugoboss.com/" target="_blank">
                            <span className="sunrise-text163">
                              Visit BOSS.COM or
                            </span>
                          </a>
                          <div className="sunrise-group327">
                            <FBNegative />
                            <TwitterNegative />
                            <InstaNegative />
                          </div>
                          <span>for more information.</span>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
                <div className="sunrise-group">
                  <Heading text="DIRECTIONS FOR USE" anchor="usage" />
                  <div className="sunrise-body sub">
                    <span className="sunrise-text-normal MOBILEBODYCOPY">
                        Spray BOSS Bottled Eau de Toilette on pulse points around the
                        body – the neck, torso and biceps – to increase the longevity
                        for a captivating perfume that lasts all day long.
                    </span>
                    <div className="sunrise-frame3861">
                      <span className="sunrise-landing-text173 HEADING">
                        DATE AFTER OPENING
                      </span>
                      <span className="sunrise-landing-text175 MOBILEBODYCOPY">
                        36 MONTHS AFTER OPENING
                      </span>
                    </div>
                  </div>
                </div>
                <div className="sunrise-group">
                  <Heading text="INGREDIENTS" anchor="ingredients" />
                  <div className="sunrise-body sub">
                    <span className="sunrise-text-normal MOBILEBODYCOPY">
                      <span>
                        ALCOHOL DENAT. · AQUA/WATER/EAU · PARFUM/FRAGRANCE · BUTYL
                        METHOXYDIBENZOYLMETHANE · LINALOOL · LIMONENE · ALCOHOL ·
                        CITRAL ·
                      </span>
                      <br></br>
                      <span>
                        TRIS (TETRAMETHYLHYDROXYPIPERIDINOL) CITRATE · CITRONELLOL ·
                        EUGENOL · CINNAMAL · GERANIOL ·
                      </span>
                      <br></br>
                      <span></span>
                      <br></br>
                      <span className="sunrise-text-normal HEADING" onClick={() => { window.scrollTo({ top: 0, behavior: 'smooth' }); setOpen((prev) => !prev)}}>FULL INGREDIENT LIST</span>
                    </span>
                  </div>
                </div>
                <div className="sunrise-group">
                  <Heading text="RECYCLING INFO" anchor="recycling" />
                  <div className="sunrise-body sub">
                    <span className="sunrise-text-normal MOBILEBODYCOPY">
                      <span>Boss bottled Eau de Toilette Spray</span>
                      <br></br>
                      <span>100 ML</span>
                      <br></br>
                      <br></br>
                      <ul className="indented-list">
                      <li>Bottle: GLASS</li>
                      <li>Cap: METAL</li>
                      <li>Cardboard: PAPER</li>
                      <li>Film: Plastic</li>
                      <li>Packaging: PAPER</li>
                      </ul>
                    </span>
                    <div className="sunrise-landing-frame3862">
                      <img
                        alt="image323970"
                        src="/external/recycle.png"
                        className="sunrise-landing-recycle"
                      />
                      <span className="sunrise-landing-text205">
                        <span onClick={() => { window.scrollTo({ top: 0, behavior: 'smooth' });setROpen((prev) => !prev)}}>SORTING INSTRUCTIONS</span>
                      </span>
                    </div>
                  </div>
                </div>
                <div className="sunrise-group">
                  <Heading text="PRODUCTION" anchor="production" />
                  <div className="sunrise-body sub">
                    <span className="sunrise-text-normal HEADING">
                      <span>EAN 737052351100</span>
                    </span>
                    <span className="sunrise-text-normal MOBILEBODYCOPY">
                      <span>Made in Spain</span>
                      <br></br>
                      <span></span>
                    </span>
                  </div>
                  <Line/>
                </div>
                <div className="sunrise-group">
                  <Heading text="LEGAL MENTION" anchor="legal" />
                  <div className="sunrise-body sub">
                    <span className="sunrise-text-normal MOBILEBODYCOPY">
                      <span>
                        Only authorized retailers are permitted to sell this product.
                      </span>
                    </span>
                  </div>
                </div>
              </div>
              <div className="sunrise-landing-mobilefooter">
                <div className="sunrise-landing-group375">
                  <img
                    alt="Vector3975"
                    src="/external/vector3975-f6fd.svg"
                    className="sunrise-landing-vector5"
                  />
                  <img
                    alt="Line3293975"
                    src="/external/line3293975-fui.svg"
                    className="sunrise-landing-line329"
                  />
                  <img
                    alt="Line3303976"
                    src="/external/line3303976-jvy.svg"
                    className="sunrise-landing-line330"
                  />
                  <span className="sunrise-landing-text221">
                    <span className="sunrise-landing-text222">© 2024, Coty Inc.</span>
                    <br></br>
                    <span className="sunrise-landing-text224"></span>
                    <span>All trademarks registered.</span>
                    <br></br>
                    <span>All rights reserved.</span>
                  </span>
                </div>
                <span className="sunrise-landing-text228">
                  <a href="https://coty.com/contact-us" target="_blank">
                    <span>Contact us</span>
                  </a>
                </span>
                <span className="sunrise-landing-text230">
                  <a href="https://coty.com/terms-use" target="_blank">
                    <span>Terms of use</span>
                  </a>
                </span>
                <span className="sunrise-landing-text232">
                  <a href="https://privacy.coty.com/en_gb" target="_blank">
                    <span>Privacy Policy</span>
                  </a>
                </span>
                <span className="sunrise-landing-text234">
                  <a href="https://coty.com/cookie-policy" target="_blank">
                    <span>Cookie Policy</span>
                  </a>
                </span>
                <span className="sunrise-landing-text236">
                  <a href="https://assets.contentstack.io/v3/assets/blted39bd312054daca/blt30d1f05d23d424e6/6595529d2d26122a18e7546f/Coty_Modern_Slavery_Statement_23_Final.pdf" target="_blank">
                    <span>Modern Slavery Act &amp;</span>
                    <br></br>
                    <span>Transparency in Supply</span>
                    <br></br>
                    <span>Chains Statement</span>
                  </a>
                </span>
                <span className="sunrise-landing-text242">
                  <a href="http://coty.com/sustainability/policies-reports" target="_blank">
                    <span>Our Policies</span>
                  </a>
                </span>
              </div>

            </div>
          </div>
        </FullIngredientsModal>
      </RecyclingModal>
    </NavigationModal>
  )
}

export default Sunrise
